import { locale } from './locale';

export const environment = {
    production: true,
    locale: locale,
    recaptchaApiKey: '6Ldj20MrAAAAAHnpCK7dErBrJSfTZp_fhEH9HHcq',
    gtagApiKey: 'G-1JJRFWL2D9',
};
